/**
 * Generated runtime TestId mirror for frontend/src/pages/CreateTargetSystem.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const CreateTargetSystemTestIds = {
  btnCancelCreateSystem: "btn-cancel-create-system",
  btnSubmitCreateSystem: "btn-submit-create-system",
  cardTitleCreateSystem: "card-title-create-system",
  inputSystemName: "input-system-name",
  selectEnvironment: "select-environment",
  env: (env_code: string) => `env-${env_code}`,
  envPrefix: () => "env-" as TestIdPrefix
} as const;
